// extracted by mini-css-extract-plugin
module.exports = {"block_item":"itemInfo_block_item__F_y1g","active":"itemInfo_active__IgxPn","images":"itemInfo_images__ulN8l"};